/**
 * Находит необходимый id в пути по pathName перед ним
 *
 *
 * @param pathName после которого будет возвращаться искомый id
 *
 * @returns id после pathName.
 *
 * @example
 * у тебя есть url: http://smetter.local:1180/estimate/23217/purchase
 * тебе нужно достать id сметы (estimate)
 * мы знаем, что id расположен по вложенному пути после estimate
 * в pathName передаем estimate и функция вернет 23217
 */

export const getIdFromUrlPath = (pathName: string) => {
    const segments = window.location.pathname.split('/');
    const indexOfPathName = segments.indexOf(pathName);
    return indexOfPathName !== -1 ? segments[indexOfPathName + 1] : null;
};
